import { ComponentProps } from 'react'

import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'

export const DEFAULT_DATA_COLLECTION_STORAGE: ComponentProps<typeof OneDataCollection>['storage'] =
  {
    features: ['*', '!search'],
  }
